module.exports = __webpack_public_path__ + "img/avatar.8480478f.png";